import { LoginResponse, LoginRequest } from '../login'
import * as _m0 from "protobufjs/minimal";
import { UserType } from '../schema';

export async function login(email: string, password: string): Promise<LoginResponse> {
    const headers = {
        'Content-Type': 'application/json',
    };

    const request: LoginRequest = {
        email: email,
        password: password,
    }

    const encodedRequest = LoginRequest.encode(request).finish();
    // const string = decoder.decode(encodedRequest); // Decode Uint8Array to string
    // const base64 = btoa(encodeURIComponent(string)); // Encode string to base64
    const base64 = _m0.util.base64.encode(encodedRequest, 0, encodedRequest.length); // Encode Uint8Array to base64

    const params = new URLSearchParams(window.location.search);
    const staging = params.get('stagingEnv')?.toLowerCase() === 'true';

    let url = "https://api.precisca.ai/authservice/login";
    if (staging) {
        url = `${url}-staging`;
    }

    const response = await fetch(
        url, {
        method: 'POST',
        headers: {
        },
        credentials: 'include', // Necessary to accept and store the HttpOnly cookie
        body: base64
    }
    );

    if (response.status === 401) {
        return {
            accessToken: '',
            refreshToken: '',
            acceptedTermsOfService: false,
            registrationComplete: false,
            userType: UserType.UNDEFINED,
            internalFlag: false
        }
    }

    if (response.status !== 200) {
        throw new Error(`Unable to login!`);
    }

    const encodedByteString = await response.text();

    const decodedByteString = atob(encodedByteString);
    const decodedBytes = new Uint8Array(decodedByteString.length);
    for (let i = 0; i < decodedByteString.length; i++) {
        decodedBytes[i] = decodedByteString.charCodeAt(i);
    }

    return LoginResponse.decode(decodedBytes);
}